import React from 'react'
import { useRecordContext } from 'react-admin'

const BlocklistName = () => {
  const record = useRecordContext()
  return <span>Blocklist {record ? `"${record.key}:${record.value}"` : ''}</span>
}

export default BlocklistName
